import { FC, MutableRefObject, useMemo } from "react";
import { get, useWatch } from "react-hook-form";

import { ITemplateData, RowBlockType } from "@framework/types";

import { PieDiagram } from "../pie";
import { BarDiagram, TFileMap } from "../bar";
import { AnalyticsTable } from "../table";
import { AnalyticsChart } from "../analytics-chart";

export interface IViewSelectorProps {
  data: ITemplateData[];
  size?: string;
  type: RowBlockType | string;
  yLabel?: string;
  chartsRef?: MutableRefObject<TFileMap>;
  header?: string;
}

export const ViewSelector: FC<IViewSelectorProps> = props => {
  const { data, size = "", type, yLabel = "", chartsRef, header } = props;

  let safeType: RowBlockType = type as RowBlockType;

  const values = useWatch();

  if (type?.startsWith("#")) {
    safeType = get(values, type.replace("#", "")) as RowBlockType;
  }

  return useMemo(() => {
    switch (safeType) {
      case RowBlockType.round3D:
        return <PieDiagram data={data} size={size} />;
      case RowBlockType.bar3D:
        return <BarDiagram data={data} size={size} yLabel={yLabel} chartsRef={chartsRef} header={header} />;
      case RowBlockType.flipBar3D:
        return <BarDiagram data={data} size={size} yLabel={yLabel} chartsRef={chartsRef} header={header} flipped />;
      case RowBlockType.table:
        return <AnalyticsTable data={data} />;
      case RowBlockType.chart:
        return <AnalyticsChart data={data} />;
      default:
        return null;
    }
  }, [safeType, data, size, yLabel, chartsRef, header]);
};
